export default {"LABEL":"Primary 主色","DESC":"原色是精髓, 一切皆从原色开始.","COMPONENTS":{"__markdown":true}}